// extracted by mini-css-extract-plugin
module.exports = {"holder":"HorizontalNavigation_holder__610WV"};